import { ActionKeys } from '~/actions/constants';
import { ActionTypes } from '~/actions/index';
import ParcelTemplate from '~/types/ParcelTemplate';

export type PackagesState = {
  readonly savePackageTemplateModalIsOpen: boolean;
  readonly parcelTemplate: Maybe<ParcelTemplate>;
  readonly defaultWeightUnit: string;
  readonly defaultDistanceUnit: string;
};

const initialState: PackagesState = {
  savePackageTemplateModalIsOpen: false,
  parcelTemplate: null,
  defaultWeightUnit: '',
  defaultDistanceUnit: '',
};

function packagesReducer(state: PackagesState = initialState, action: ActionTypes): PackagesState {
  switch (action.type) {
    case ActionKeys.SETTINGS_CLOSE_SAVE_PACKAGE_TEMPLATE_MODAL:
      return {
        ...state,
        savePackageTemplateModalIsOpen: false,
        parcelTemplate: null,
      };
    case ActionKeys.SETTINGS_OPEN_SAVE_PACKAGE_TEMPLATE_MODAL:
      return {
        ...state,
        parcelTemplate: action.parcelTemplate,
        savePackageTemplateModalIsOpen: true,
      };
    case ActionKeys.FETCH_PACKAGE_DEFAULT_UNITS_SUCCESS:
      return {
        ...state,
        defaultWeightUnit: action.payload.defaultWeightUnit,
        defaultDistanceUnit: action.payload.defaultDistanceUnit,
      };
    default:
      return state;
  }
}

export default packagesReducer;
